import React from "react";
import ProfileTitle from "../../../../components/ProfileTitle";
import * as api from '../../../../apis/platforms/admin/baseData'
import useAntTable from "../../../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import {Button, Divider, Popconfirm, Space, Tag} from "antd";
import ExpressEditModal from "./expressEditModal";
import useFormModal from "../../../../utils/useFormModal";
import {useRequest} from "ahooks";
import {onSetDefaultExpress} from "../../../../apis/platforms/admin/baseData";

export default function Express() {

    const {tableProps, refresh} = useAntTable(api.getExpresses, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.editExpress,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteExpress, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const {run: onSetDefault} = useRequest(api.onSetDefaultExpress, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '快递名称',
            dataIndex: 'name'
        },
        {
            title: '描述',
            dataIndex: 'desc'
        },
        {
            title: '冷链',
            dataIndex: 'coldChain',
            render: (value) => value ? '是' : '否'
        },
        {
            title: '默认快递',
            dataIndex: 'default',
            render: (value) => value ? <Tag color={'green'}>默认</Tag> : null
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Space split={<Divider type="vertical"/>}>
                    <a onClick={() => {
                        setVisible(true, record)
                    }}>编辑</a>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                    <Popconfirm title={'是否确定设置为默认快递'} onConfirm={() => onSetDefault(record.id)}>
                        <a>设为默认</a>
                    </Popconfirm>
                </Space>
            )
        }
    ]

    return (
        <div>
            <ProfileTitle>快递</ProfileTitle>
            <StandardTable {...tableProps} columns={columns} showCard={false} rowKey={'id'} toolbar={
                <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
            }/>
            <ExpressEditModal {...modalProps}/>
        </div>
    )
}
